<template>
  <div class="row border-line-down">
    <nav
      v-if="data.length"
      class="col footer-links"
    >
      <template v-for="(section, index) in data">
        <section
          v-if="!(section.hideOnBhs && isStore)"
          :key="index"
          class="footer-links__section"
        >
          <a
            v-if="section.heading"
            :href="(section && section.headingLink && section.headingLink.endsWith('/handla/') && onlineUrl) ? onlineUrl : section.headingLink"
            class="footer-links__title"
            v-text="section.heading"
          />
          <ul class="footer-links__list">
            <template
              v-for="link in section.links"
            >
              <li
                v-if="!(link.hideOnBhs && isStore)"
                :key="link.text"
                class="footer-links__list-item"
              >
                <a
                  :href="(link && link.url && link.url.endsWith('/handla/') && onlineUrl) ? onlineUrl : link.url"
                  class="footer-links__link"
                  v-text="link.text"
                />
              </li>
            </template>
            <li
              v-if="(showOneTrustSettingsLink && section.heading == 'ICA')"
              class="footer-links__list-item"
            >
              <button
                id="ot-sdk-btn"
                class="footer-links__link link ot-sdk-show-settings"
                type="button"
                aria-haspopup="true"
                v-text="'Inställningar av cookies'"
              />
            </li>
          </ul>
        </section>
      </template>
    </nav>
    <div
      v-else
      class="footer-links__empty"
    >
      Det finns ingen footer länkar
    </div>
  </div>
</template>

<script>
import baseComponentSettings from "@/vue/components/baseComponentSettings"

export default {
  mixins: [baseComponentSettings],
  props: {
    storeLinks: {
      type: Object,
      default: null
    },
    isStore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showOneTrustSettingsLink: true,
      onlineUrl: ''
    }
  },
  destroyed () {
    document.removeEventListener("topNavStoreChange", this.handleTopNavStoreChangeEvent, false)
  },
  mounted (){
    // To let the footer know which onlineurl to use we listen to an custom event from topNav.
    // When we have an vuex store spanning all instances we kan use that instead.
    document.addEventListener("topNavStoreChange", this.handleTopNavStoreChangeEvent, false)

    //const searchParams = window.location.search
    //const hasActiveOneTrustSession = searchParams.includes("otactive")
    this.showOneTrustSettingsLink = true
  },
  methods: {
    handleTopNavStoreChangeEvent (e) {
      this.onlineUrl = e.detail.onlineUrl
    }
  }
}
</script>
<style lang="scss">

.footer-links {
  margin-bottom: 1rem;
  column-count: 1;
  column-gap: 1rem;
  width: 100%;

  @include media-breakpoint-up(md) {
    column-count: 2;
  }

  @include media-breakpoint-up(lg) {
    column-count: 4;
  }

  &__section {
    // stylelint-disable-next-line property-no-vendor-prefix
    -webkit-column-break-inside: avoid;
    break-inside: avoid-column;
    page-break-inside: avoid;
    display: table;
    margin: 0 0 1rem;
  }

  &__title {
    @include font(text, 3, "bold");

    color: $color-grey-dark;
    display: block;
    margin: 0 0 1rem;
    text-decoration: none;
  }

  &__list {
    margin: 0;
    padding: 0;
  }

  &__list-item {
    @include font(text, 2, "normal");

    display: flex;
    list-style: none;
    margin: 0 0 1rem;

    a {
      text-decoration: none;
      color: $color-secondary-text;

      &:hover {
        color: $color-pink-light;
      }
    }
  }

  .ot-sdk-show-settings {
    @include font(text, 2, "normal");

    cursor: pointer;
    padding: 0;
    background: transparent;
    outline: none;
    border: none;
    color: $color-secondary-text;

    &:hover {
      color: $color-pink-light;
    }
  }

  &__empty {
    padding: 20px;
    margin: 0 auto;

    @include font(text, 2, "normal");
  }
}
</style>
